import React from 'react';

import ImageSequence from './ImageSequence.js';

const images = import.meta.glob('../images/{blurred,unoptimized,optimized}/*.png', {
    eager: true,
    query: '?url',
    import: 'default',
});

export default ({size, n, mobileN, source, alt}) => <ImageSequence
    n={n} mobileN={mobileN}
    imageGetter={i => [images[`../images/${source}/${i}.png`], size, alt(i)]}
/>;
